export default __webpack_public_path__ + "static/media/uploader-caresensBt-problem-1.cfd93663.png";